<template>
    <div class="information-skeleton">
        <div class="information-skeleton-content">
            <div class="information-skeleton-content-title"></div>
            <div class="information-skeleton-content-source"></div>
            <div class="information-skeleton-content-label"></div>
            <div v-for="index in contentListNum" :key="index" class="information-skeleton-content-list"></div>
            <div class="information-skeleton-content-disclaimer"></div>
            <div class="information-skeleton-content-bottom"></div>
        </div>
        <!-- <div class="information-skeleton-recommend">
            <div class="information-skeleton-recommend-title"></div>
            <div class="information-skeleton-recommend-content">
                <div v-for="index in recommendListNum" :key="index">
                    <div class="information-skeleton-recommend-content-top"></div>
                    <div class="information-skeleton-recommend-content-bottom"></div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            contentListNum: 9,
            recommendListNum: 3
        };
    }
};
</script>

<style lang="less" scoped>
.information-skeleton {
    display: flex;

    &-content {
        background-color: #fff;
        width: 784px;
        height: 904px;
        margin-right: 12px;
        padding: 0 56px;
        border-radius: 8px;

        &-title {
            margin-top: 40px;
            width: 248px;
            height: 38px;
            background-color: #f3f3f4;
            margin: 40px auto 44px;
            border-radius: 2px;
        }

        &-source {
            width: 225px;
            height: 20px;
            background-color: #f9f9fa;
            border-radius: 2px;
            position: relative;

            &::after {
                content: '';
                display: block;
                width: 784px;
                height: 1px;
                background-color: rgba(179, 179, 187, .3);
                position: absolute;
                bottom: -10px;
            }
        }

        &-label {
            margin: 20px 0 12px;
            background-color: #f9f9fa;
            width: 304px;
            height: 20px;
            border-radius: 2px;
        }

        &-list {
            margin: 30px 0;
            background-color: #f9f9fa;
            width: 784px;
            height: 28px;
            border-radius: 2px;
        }

        &-disclaimer {
            margin-top: 57px;
            width: 784px;
            height: 20px;
            background-color: #f9f9fa;
            position: relative;
            border-radius: 2px;

            &::before {
                content: '';
                display: block;
                width: 784px;
                height: 1px;
                background-color: rgba(179, 179, 187, .3);
                position: absolute;
                top: -10px;
            }
        }

        &-bottom {
            width: 412px;
            height: 20px;
            border-radius: 2px;
            background-color: #f9f9fa;
            margin: 10px 0 80px;
        }
    }

    &-recommend {
        width: 290px;
        height: 334px;

        &-title {
            width: 158px;
            height: 26px;
            border-radius: 2px;
            background-color: #e8e8e8;
            margin-bottom: 12px;
        }

        &-content {
            background-color: #fff;
            border-radius: 8px;
            width: 258px;
            height: 284px;
            padding: 4px 16px 8px;

            &-top {
                width: 258px;
                height: 24px;
                background-color: #f9f9fa;
                border-radius: 2px;
                margin: 20px 0;
            }

            &-bottom {
                width: 222px;
                height: 24px;
                background-color: #f9f9fa;
                border-radius: 2px;
                margin: 20px 0;
            }
        }
    }
}
</style>
